import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/components/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPricingPage from "@/pages/ServicesPricingPage";
import ContactPage from "@/pages/ContactPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import InsightsListPage from "@/pages/InsightsListPage";
import { PAGES } from "@/data/pages";
import { resolveLegacyRedirect } from "@/data/legacy-redirects";

// Scroll restore on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

// Catch-all that redirects known legacy URLs (from the old abs-solutions.com.au
// site) to their new equivalents and falls back to the homepage otherwise.
function LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  const target = resolveLegacyRedirect(pathname);
  if (target) {
    return <Navigate to={`${target}${search}${hash}`} replace />;
  }
  return <Navigate to="/" replace />;
}

const renderPage = (page) => {
  if (page.type === "home") return <HomePage />;
  if (page.type === "about") return <AboutPage />;
  if (page.type === "pricing") return <ServicesPricingPage />;
  if (page.type === "contact") return <ContactPage />;
  if (page.type === "insights-list") return <InsightsListPage />;
  return <ServiceDetailPage pageId={page.id} />;
};

const SiteShell = ({ children }) => (
  <LanguageProvider>
    <ScrollToTop />
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  </LanguageProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* English routes */}
          {PAGES.map((p) => {
            const path = p.slug ? `/${p.slug}` : "/";
            return (
              <Route
                key={`en-${p.id}`}
                path={path}
                element={<SiteShell>{renderPage(p)}</SiteShell>}
              />
            );
          })}

          {/* Chinese routes under /zn */}
          {PAGES.map((p) => {
            const path = p.slug ? `/zn/${p.slug}` : "/zn";
            return (
              <Route
                key={`zn-${p.id}`}
                path={path}
                element={<SiteShell>{renderPage(p)}</SiteShell>}
              />
            );
          })}

          {/* Catch-all: redirect known legacy URLs, fallback to home */}
          <Route path="*" element={<LegacyRedirect />} />
        </Routes>
      </BrowserRouter>

    </div>

  );
}

export default App;
